import React from "react";
import { SlEarphonesAlt } from "react-icons/sl";

export default function ServicesMunicipauxEmptyState() {
  return (
    <div className="flex min-h-[280px] items-center justify-center p-8">
      <div className="max-w-md text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-[1.5rem] bg-slate-100 text-3xl text-slate-400 dark:bg-slate-800 dark:text-slate-500">
          <SlEarphonesAlt />
        </div>

        <h3 className="mt-5 text-xl font-bold text-slate-950 dark:text-white">
          Aucun service trouvé
        </h3>

        <p className="mt-2 text-sm leading-6 text-slate-500 dark:text-slate-400">
          Modifiez les filtres ou créez une nouvelle fiche pour alimenter la
          page des services municipaux.
        </p>
      </div>
    </div>
  );
}